import { cn } from "lib/utils"

interface StarAlertProps {
  //   title: string
  children: React.ReactNode
  className?: string
  icon?: React.ReactNode
  type?: "info" | "warning" | "success" | "error"
}

export default function StarAlert(props: StarAlertProps) {
  return (
    <div
      className={cn(
        "text-content-100 bordered-1 !border-transparent bg-selected-lighter flex gap-4 text-md",
        // "dark:bg-violet-400/5 dark:!border-violet-400/15  dark:border-solid dark:!border-2",
        "dark:bg-[rgba(0,0,0,0.04)] dark:!border-selected-light dark:border-solid dark:!border-2",
        props.type === "info" && "bg-blue-500/10 [&_svg]:!text-blue-500 [&_svg]:opacity-100 dark:bg-blue-500/5 dark:!border-blue-500/15  dark:border-solid dark:!border-2",
        props.type === "warning" && "bg-yellow-500/20 [&_svg]:!text-yellow-800 [&_svg]:opacity-100 dark:bg-yellow-500/5 dark:!border-yellow-500/15  dark:border-solid dark:!border-2",
        props.className,
      )}
    >
      {props.icon ? (
        <i className="fc !size-5 opacity-35 shrink-0 mt-0.5">{props.icon}</i>
      ) : (
        <IconMageStarsAFill className="!size-5 opacity-35 shrink-0 mt-0.5" />
      )}
      <div className="leading-5">{props.children}</div>
    </div>
  )
}
